// Calculates DOM node's offset from target DOM node

export const offsetTill = (node: HTMLElement, target?: HTMLElement | Element | Window, direction?: 'left') => {
  let current: HTMLElement | null = node;
  let offset = 0;
  do {
    if (direction === 'left') {
      offset += current.offsetLeft;
    } else {
      offset += current.offsetTop;
    }
    current = current.offsetParent as HTMLElement | null;
  } while (current && current !== target);
  return offset;
};
